import { ChevronRight } from "@mui/icons-material";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { Block } from "../../../../shared";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ReferralIcon } from "../../../../../icons";

export function ReferralBlock() {
  const navigate = useNavigate();
  const { t } = useTranslation("profile");

  return (
    <Block sx={{ paddingTop: "4px", paddingBottom: "4px" }}>
      <ListItem
        onClick={() => navigate("/referral")}
        sx={{
          paddingInline: 0,
          paddingBlock: "8px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "12px",
          cursor: "pointer",
        }}
      >
        <ListItemIcon
          sx={(theme) => ({
            backgroundColor:
              theme.palette.mode === "dark"
                ? "rgba(51,119,255,0.16)"
                : "rgba(51,119,255,0.10)",
            color: theme.palette.primary.main,
            minWidth: "36px",
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "10px",
            flexShrink: 0,
          })}
        >
          <ReferralIcon />
        </ListItemIcon>

        <ListItemText
          sx={{ margin: 0, flexGrow: 1 }}
          primary={
            <Typography sx={{ fontSize: "15px", fontWeight: 500 }}>
              {t("blocks.referral")}
            </Typography>
          }
        />

        <ChevronRight sx={{ color: "#b0b0b0", flexShrink: 0 }} />
      </ListItem>
    </Block>
  );
}
